import { useOrganizationsServiceOrganizationsTeamsRetrieve } from '@organization/api/queries'

import { Flex } from 'antd'

import { useParams } from 'react-router-dom'

import { TeamProfile, UsersTableContainer } from '../components'

export const TeamDetails = () => {
  const params = useParams()

  const { data } = useOrganizationsServiceOrganizationsTeamsRetrieve(
    {
      id: Number(params.teamId)
    },
    [Number(params.teamId)]
  )

  return (
    <Flex vertical gap={20}>
      <TeamProfile team={data} />

      <UsersTableContainer team={data} />
    </Flex>
  )
}
